import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import AboutCompany from './components/AboutCompany/AboutCompany';
import ClientReview from './components/ClientReview/ClientReview';
import Contact from './components/Contact/Contact';
import Counter from './components/Counter/Counter';
import Footer from './components/Footer/Footer';
import NavBar from './components/NavBar/NavBar';
import OurServices from './components/OurServices/OurServices';
import Pricing from './components/Pricing/Pricing';
import TopBanner from './components/TopBanner/TopBanner';

AOS.init();

function App() {
    return (
        <div>
            <NavBar />
            <TopBanner />
            <OurServices />
            <AboutCompany />
            <Counter />
            <Pricing />
            <Contact />
            <ClientReview />
            <Footer />
        </div>
    );
}

export default App;
